import { render, staticRenderFns } from "./SemiProductComponent.vue?vue&type=template&id=47775ba1&"
import script from "./SemiProductComponent.vue?vue&type=script&lang=js&"
export * from "./SemiProductComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports